import script from "./PrayPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrayPage.vue?vue&type=script&setup=true&lang=js"

import "./PrayPage.vue?vue&type=style&index=0&id=581cfd04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581cfd04"]])

export default __exports__